import { render, staticRenderFns } from "./MultipleMultimediaComponent.vue?vue&type=template&id=f4e8b378"
import script from "./MultipleMultimediaComponent.vue?vue&type=script&lang=js"
export * from "./MultipleMultimediaComponent.vue?vue&type=script&lang=js"
import style0 from "./MultipleMultimediaComponent.vue?vue&type=style&index=0&id=f4e8b378&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports